import { Typography } from '@mui/material'
import { memo } from 'react'
import { useTranslation } from '@pasteltech/i18n-react'
import styled from 'styled-components'

type ForbiddenPagePropType = {}

const Root = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  color: grey;
  align-items: center;
  justify-content: center;
`

export const ForbiddenPage = memo<ForbiddenPagePropType>(() => {
  const { t } = useTranslation()
  return (
    <Root>
      <Typography variant="h4">{t('common.forbidden')}</Typography>
    </Root>
  )
})

ForbiddenPage.displayName = 'ForbiddenPage'
